module.exports = __webpack_public_path__ + "static/media/autoCADAddons3.7fbee0b2.png";